import React, { useMemo, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import PbUmkuService from '../../../../services/pbumku/PbumkuService';
// import ModalCetakLamp from './ModalCetakLamp';

const ModalLampTeknis = ({ showAddLamp, handleCloseAddLamp, rowData, reloadList }) => {
    // console.log(rowData)
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [nomorRefTeknis, setNomorRefTeknis] = useState('')
    const [kategori, setKategori] = useState('')
    const [komoditas, setKomoditas] = useState('')
    const [jenisSediaanObat, setJenisSediaanObat] = useState('')
    const [peruntukan, setPeruntukan] = useState('')

    const onChangeNoRefTeknis = (e) => {
        setNomorRefTeknis(e.target.value)
    }

    const onChangeKategori = (e) => {
        setKategori(e.target.value)
    }

    const onChangeKomoditas = (e) => {
        setKomoditas(e.target.value)
    }

    const onChangeSediaanObat = (e) => {
        setJenisSediaanObat(e.target.value)
    }

    const onChangePeruntukan = (e) => {
        setPeruntukan(e.target.value)
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmLampiran, setShowConfirmLampiran] = useState(false)
    const handleCloseConfirmLampiran = () => setShowConfirmLampiran(false)
    const [showLaporanSuccess, setShowLaporanSuccess] = useState(false)
    const [showLaporanFailed, setShowLaporanFailed] = useState(false)

    const saveLampiran = () => {
        setShowConfirmLampiran(true)
    }

    const handleClickSimpan = async () => {
        setLoadingSave(true)
        try {
            let jsonLampiran = {
                idlaphdr: rowData.idLapHdr,
                idoss: rowData.idoss,
                idpryk: rowData.idpryk,
                idchecklist: rowData.idchecklist,
                idspt: rowData.idSpt,
                nib: rowData.nib,
                nomorReferensiTeknis: nomorRefTeknis,
                kategori: kategori,
                komoditas: komoditas,
                jenisSediaanObat: jenisSediaanObat,
                peruntukanProduk: peruntukan,
                createdBy: localStorage.getItem("userId"),
                createdDate: new Date()
            }
            const _resLampiran = await pbumkuService.saveLaporanLampiran(jsonLampiran)
            if (_resLampiran.data.kode === '200') {
                setShowConfirmLampiran(false)
                setShowLaporanSuccess(true)
            } else {
                setShowConfirmLampiran(false)
                setShowLaporanFailed(true)
            }
        } catch (error) {
            console.log(error)
            setShowLaporanFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickSimpanSuccess = () => {
        setShowLaporanSuccess(false)
        handleCloseAddLamp()
        reloadList(0, 10)
    }

    const handleClickSimpanFailed = () => {
        setShowLaporanFailed(false)
    }
    // const [showCetakLamp, setShowCetakLamp] = useState(false)
    // const handleCloseCetakLamp = () => setShowCetakLamp(false)

    // const handleClickCetakLamp = () => {
    //     setShowCetakLamp(true)
    // }


    return (
        <>
            <Modal show={showAddLamp} onHide={handleCloseAddLamp} backdrop='static' keyboard={false} scrollable={true} size='xl' centered>
                <Modal.Header><h6>Form Lampiran Teknis</h6></Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Perizinan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.urIzin} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">NIB / Nama Perusahaan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && (rowData.nib + ' / ' + rowData.namaPerseroan)} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor / Tanggal Permohonan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="idIzin" defaultValue={rowData !== null && rowData.idIzin + ' / ' + rowData.tglPermohonan} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor Kegiatan Usaha</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_proyek" defaultValue={rowData !== null && rowData.nomorProyek} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Usaha</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.uraianUsaha} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor / Tanggal SPT</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.nomorSpt + ' / ' + rowData.tanggalSpt} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor Referensi Teknis</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-8 form-control-sm" name="nomor_ref" onChange={onChangeNoRefTeknis} />{' '}
                        </div>
                    </div>

                    {
                        rowData !== null && (rowData.urIzinSingkat === 'CBIB' || rowData.urIzinSingkat === 'CPIB') &&
                        <div className="row mb-3">
                            <label className="col-sm-4 col-form-label-sm">Komoditas</label>
                            <div className="col-sm-8">
                                <input type="text" className="col-sm-8 form-control-sm" name="komoditas" onChange={onChangeKomoditas} />{' '}
                            </div>
                        </div>
                    }
                    {
                        rowData !== null && rowData.urIzinSingkat === 'CDOIB' &&
                        <div className="row mb-3">
                            <label className="col-sm-4 col-form-label-sm">Kategori</label>
                            <div className="col-sm-8">
                                <input type="text" className="col-sm-8 form-control-sm" name="kategori" onChange={onChangeKategori} />{' '}
                            </div>
                        </div>
                    }
                    {
                        rowData !== null && rowData.urIzinSingkat === 'CPOIB' &&
                        <>
                            <div className="row mb-3">
                                <label className="col-sm-4 col-form-label-sm">Kategori</label>
                                <div className="col-sm-8">
                                    <input type="text" className="col-sm-8 form-control-sm" name="kategori" onChange={onChangeKategori} />{' '}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-4 col-form-label-sm">Jenis Sediaan Obat</label>
                                <div className="col-sm-8">
                                    <input type="text" className="col-sm-8 form-control-sm" name="sediaan_obat" onChange={onChangeSediaanObat} />{' '}
                                </div>
                            </div>
                        </>
                    }
                    {
                        rowData !== null && rowData.urIzinSingkat === 'CPPIB' &&
                        <div className="row mb-3">
                            <label className="col-sm-4 col-form-label-sm">Peruntukan Produk</label>
                            <div className="col-sm-8">
                                <input type="text" className="col-sm-8 form-control-sm" name="peruntukan" onChange={onChangePeruntukan} />{' '}
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => saveLampiran()}>Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseAddLamp}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* <ModalCetakLamp showCetakLamp={showCetakLamp} handleCloseCetakLamp={handleCloseCetakLamp} rowData={rowData}/> */}
            {
                showConfirmLampiran &&
                <SweetAlert
                    title="Simpan Lampiran Teknis?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    reverseButtons={true}
                    btnSize="sm"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmLampiran}
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showLaporanSuccess &&
                <SweetAlert
                    title="Lampiran Berhasil Disimpan"
                    success
                    onConfirm={handleClickSimpanSuccess}
                    btnSize="sm"
                />
            }
            {
                showLaporanFailed &&
                <SweetAlert
                    title="Lampiran Gagal Disimpan"
                    danger
                    onConfirm={handleClickSimpanFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalLampTeknis